import { PersonType } from "@/helpers/types/types.ts";
import { EngineStoreData } from "@/stores/EngineStore/EngineStore.ts";
import { ChildType } from "@/stores/EngineStore/interfaces/ChildType.ts";
import { v4 as uuidv4 } from "uuid";

export const setChildrenHelper = (state: EngineStoreData, count: number, itemId: string) => {
  const existingChildren =
    state.cartAccommodationItems.find((CAI) => CAI.id === itemId)?.children.slice(0, count) || [];

  // Preserve existing ages when updating the children array
  const newChildren: ChildType[] = Array.from({ length: count - existingChildren.length }, () => ({
    id: uuidv4(),
    age: 0,
    type: PersonType.Child,
  }));

  return {
    cartAccommodationItems: state.cartAccommodationItems?.map((CAI) => {
      if (CAI.id === itemId) {
        return { ...CAI, children: [...existingChildren, ...newChildren] };
      }
      return CAI;
    }),
  };
};
